/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {EmojiInput as ɵa} from '../input/emoji-input.component';